import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { generateExternalStyle } from './externalStyles';
var generateStyle = function generateStyle(componentTheme) {
  return _objectSpread({
    nav: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: "".concat(componentTheme.navPaddingTopBottom, " ").concat(componentTheme.navPaddingLeftRight),
      borderBottom: "".concat(componentTheme.navBorderWidth, " solid ").concat(componentTheme.navBorderColor),
      backgroundColor: componentTheme.navBackgroundColor,
      position: 'sticky',
      top: 0,
      width: '100%',
      boxSizing: 'border-box',
      zIndex: 4444,
      /**
       * For MS Edge
       * When they switch to chromium
       * check to see if sticky works.
       */
      '@supports (-ms-ime-align: auto)': {
        position: 'relative'
      }
    },
    crumbs: {
      flex: 1
    }
  }, generateExternalStyle());
};
export default generateStyle;